var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { class: ["arena-indicator", { mobile: _vm.isMobile }] },
    _vm._l(_vm.arenaList, function (arena) {
      return _c("div", { key: arena.id }, [
        _c(
          "div",
          {
            class: [
              "arena-indicator-button-wrapper",
              arena.isHot ? "hot-border" : "",
            ],
          },
          [
            _c(
              "div",
              {
                class: [
                  "arena-indicator-button",
                  "inner",
                  _vm.indicatorStatus(arena.fightStatus),
                  { active: _vm.isArenaActive(arena) },
                  { "fight-started": _vm.isFightStarted(arena) },
                  { "fade-animation": _vm.shouldFadeAnimation(arena) },
                ],
                on: {
                  click: function ($event) {
                    return _vm.updateArena(arena)
                  },
                },
              },
              [
                _c("div", { staticClass: "fight-bg" }),
                _c("div", { staticClass: "flag-pill" }, [
                  _c("div", { staticClass: "flag-ring" }, [
                    _c("img", {
                      staticClass: "flag-img",
                      attrs: {
                        src: _vm.getFlagSrc(arena.country),
                        alt: "flag",
                      },
                    }),
                  ]),
                ]),
                _c("div", { staticClass: "arena-code" }, [
                  _vm._v(_vm._s(arena.code)),
                ]),
              ]
            ),
          ]
        ),
      ])
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }